<template>
  <div class="main-base">
    <header>
      <app-header/>
    </header>
    <menu>
      <app-menu/>
    </menu>
    <main>
      <router-view/>
    </main>
  </div>
</template>

<script>
import AppMenu from './app-menu'
import AppHeader from './app-header'

export default {
  name: 'AppContainer',
  components: {
    AppHeader,
    AppMenu
  }
}
</script>

<style lang="scss" scoped>
  .main-base {
    background-color: $secondary;
    overflow: hidden;
    position: absolute;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    header {
      position: absolute;
      height: 60px;
      z-index: 100;
      width: 100%;
      top: 0;
      left: 0;
    }
    menu {
      position: absolute;
      top: 60px;
      left: 0;
      height: 100vh;
      margin: 0;
      padding: 0;
      width: 60px;
    }
    main {
      height: 100vh;
      overflow: auto;
      padding: 60px 0 0 60px;
    }

  }
</style>



// WEBPACK FOOTER //
// src/views/app/app-container.vue